import { blackColors } from 'assets/jss/material-dashboard-pro-react';

const setOfNumbersDialogStyle = () => ({
	tableWrapper: {
		margin: '16px 58px 40px 58px',
	},
	description: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-start',
		'& p': {
			marginRight: '3px',
		},
		'& > svg': {
			margin: 0,
			color: blackColors[0],
		},
	},
});

export default setOfNumbersDialogStyle;
